module.exports = __webpack_public_path__ + "img/goldenstar.abaa1b31.svg";